const ActionTypes = {
};

export default ActionTypes;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/redux/reducers/env/ActionTypes.ts